import { IAction } from "../../../models/Action";
import { entitlementSelectedItem } from "./request";

export const actionTypes = {
  FETCH_ENTITLEMENT_REQUEST: "FETCH_ENTITLEMENT_REQUEST",
  FETCH_ENTITLEMENT_REQUEST_SUCCESS: "FETCH_ENTITLEMENT_REQUEST_SUCCESS",
  FETCH_ENTITLEMENT_REQUEST_FAILURE: "FETCH_ENTITLEMENT_REQUEST_FAILURE",
  SELECT_DETAIL_ENTITLEMENT: "SELECT_DETAIL_ENTITLEMENT",

  FETCH_BENEFICIARY_REQUEST: "FETCH_BENEFICIARY_REQUEST",
  FETCH_BENEFICIARY_REQUEST_SUCCESS: "FETCH_BENEFICIARY_REQUEST_SUCCESS",
  FETCH_BENEFICIARY_REQUEST_FAILURE: "FETCH_BENEFICIARY_REQUEST_FAILURE",

  GET_BR_ENTITLEMENT_IN_REFERENCE: "GET_BR_ENTITLEMENT_IN_REFERENCE",
  GET_BR_ENTITLEMENT_IN_REFERENCE_SUCCESS:
    "GET_BR_ENTITLEMENT_IN_REFERENCE_SUCCESS",
  GET_BR_ENTITLEMENT_IN_REFERENCE_FAILURE:
    "GET_BR_ENTITLEMENT_IN_REFERENCE_FAILURE",

  SET_BR_ENTITLEMENT_IN_REFERENCE: "SET_BR_ENTITLEMENT_IN_REFERENCE",
};

export const getBrEntitlementsAction = (payload: string) => ({
  type: actionTypes.GET_BR_ENTITLEMENT_IN_REFERENCE,
  payload,
});
export const getBrEntitlementsActionSuccess = (payload: any) => ({
  type: actionTypes.GET_BR_ENTITLEMENT_IN_REFERENCE_SUCCESS,
  payload,
});
export const getBrEntitlementsActionFailure = (payload: any) => ({
  type: actionTypes.GET_BR_ENTITLEMENT_IN_REFERENCE_FAILURE,
  payload,
});

export const fetchEntitlementRequest = (): IAction => ({
  type: actionTypes.FETCH_ENTITLEMENT_REQUEST,
});

export const fetchEntitlementRequestSuccess = (payload: any): IAction => ({
  type: actionTypes.FETCH_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const fetchEntitlementRequestFailure = (error: any): IAction => ({
  type: actionTypes.FETCH_ENTITLEMENT_REQUEST_FAILURE,
  error,
});

export const selectDetailEntitlement = (
  payload: entitlementSelectedItem
): IAction => ({
  type: actionTypes.SELECT_DETAIL_ENTITLEMENT,
  payload,
});

export const setBREntitlements = (payload: any[]) => ({
  type: actionTypes.SET_BR_ENTITLEMENT_IN_REFERENCE,
  payload,
});

export const fetchBeneficiaryRequest = (
  payload: entitlementSelectedItem
): IAction => ({
  type: actionTypes.FETCH_BENEFICIARY_REQUEST,
  payload,
});

export const fetchBeneficiaryRequestSuccess = (payload: any): IAction => ({
  type: actionTypes.FETCH_BENEFICIARY_REQUEST_SUCCESS,
  payload,
});

export const fetchBeneficiaryRequestFailure = (error: any): IAction => ({
  type: actionTypes.FETCH_BENEFICIARY_REQUEST_FAILURE,
  error,
});
